import confetti from "canvas-confetti"
import React, { useEffect, useState } from "react"
import ProfileMenu from "../../../components/CommonForBoth/TopbarDropdown/ProfileMenu"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getUserDetailsRequest } from "../../../redux/actions/auth"
const NomineeBookingConfirm = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [userShortlisted, setUserShortlisted] = useState(false)
  const [userFinalized, setUserFinalized] = useState(false)

  const token = useSelector(state => state.auth.token)
  const user = useSelector(state => state.auth.user)
  const awards = useSelector(state => state.auth.awards)
  const dashboardData = useSelector(state => state.auth.dashboardData) || {}
  const activeAwardUrl =
    dashboardData.active_award && dashboardData.active_award.length > 0
      ? dashboardData.active_award[0].url
      : ""

  useEffect(() => {
    if(!awards || awards.length === 0) {
      navigate("/awards/" + activeAwardUrl, { replace: true })
    }
    if (awards && awards.length > 0 && awards[0].status === "shortlisted") {
      setUserShortlisted(true)
    }
    if (awards && awards.length > 0 && awards[0].status === "s2_paid") {
      setUserShortlisted(false)
      setUserFinalized(true)
      invokeConfetti()
    }
  }, [awards])

  useEffect(() => {
    if (token === null) {
      navigate("/login", { replace: true })
    } else {
      dispatch(getUserDetailsRequest())
    }
  }, [])
  const invokeConfetti = () => {
    const isMobile = window.innerWidth < 768

    const fire = (particleRatio, opts) => {
      confetti({
        particleCount: Math.floor(210 * particleRatio),
        spread: 55,
        startVelocity: isMobile ? 30 : 45,
        ticks: isMobile ? 120 : 200,
        gravity: 0.9,
        scalar: isMobile ? 0.7 : 1,
        colors: ["#ec4899", "#a855f7", "#f472b6", "#c084fc"],
        ...opts,
      })
    }
    fire(0.25, {
      origin: { x: 0, y: 0.6 },
      angle: 60,
    })

    fire(0.2, {
      origin: { x: 0, y: 0.6 },
      angle: 60,
      spread: 180,
    })
    fire(0.25, {
      origin: { x: 1, y: 0.6 },
      angle: 120,
    })

    fire(0.2, {
      origin: { x: 1, y: 0.6 },
      angle: 120,
      spread: 180,
    })
    fire(0.2, {
      origin: { x: 0.5, y: 0.5 },
      angle: 90,
      spread: 120,
      startVelocity: 40,
    })
  }
  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="newaward-maincontainer p-4">
          {userShortlisted ? (
            <div className="congrats-box content-boxnew">
              <div className="success-icon">🎉</div>
              <h1 className="h1">Congratulation!</h1>
              <p>
                {`Hi ${user.first_name} ${
                  user.last_name
                }, You have been shortlisted for ${
                  awards && awards.length > 0
                    ? awards[0].category_label
                    : "______"
                } category. Please proceed to
              the next step.`}
              </p>
              <button
                className="primary-button"
                onClick={() => {
                  navigate("/shortlisted-nominee-form", { replace: true })
                }}
              >
                Proceed to Final Step
              </button>
            </div>
          ) : !userFinalized ? (
            <div className="congrats-box content-boxnew">
              <p>{`Dear ${user.first_name} ${user.last_name},`}</p>
              <p>
                Warm greetings from <strong>PULA Pune Ladies</strong>
              </p>
              <p>
                Thank you for your nomination submission for the PULA
                Entrepreneurship Awards 2025. We are pleased to confirm the
                receipt of your nomination.
              </p>
              <p>
                Please note that this communication serves as a nomination
                confirmation only. All nominations received will be reviewed and
                evaluated through a structured jury selection process, and the
                shortlisted nominations will be informed separately at the
                appropriate stage.
              </p>
              <p>
                The PULA Entrepreneurship Awards aim to recognize entrepreneurs
                who demonstrate innovation, resilience, and a commitment to
                creating meaningful social and economic impact. We truly
                appreciate your interest in being part of this initiative.
              </p>
              <p>
                Should you require any additional information in the interim,
                please feel free to reach out to us on. Further updates
                regarding the jury process and next steps will be shared in due
                course.
              </p>
              <p>
                Warm regards, <br />
                Sonia Konjeti <br />
                Founder & CEO - PULA Pune Ladies
              </p>
            </div>
          ) : (
            <>
              {/* APPROVE NOMINEE */}
              <div className="congrats-box content-boxnew">
                <div className="success-icon">🏆</div>
                <h1 className="h1">Congratulations, {user.first_name}!</h1>
                <p>{`Dear ${user.first_name} ${user.last_name},`}</p>
                <p>
                  Warm greetings from <strong>PULA Pune Ladies</strong>
                </p>
                <p>
                  We are thrilled to announce that you are the{" "}
                  <strong>
                    winner of the{" "}
                    {awards && awards.length > 0
                      ? awards[0].category_label
                      : ""}
                    {" "}category
                  </strong>{" "}
                  at the PULA Entrepreneurship Awards 2025. This is a
                  remarkable achievement and a testament to your dedication,
                  innovation, and entrepreneurial spirit.
                </p>
                <p>
                  Someone from the <strong>PULA team</strong> will be reaching
                  out to you shortly to share the next steps, including details
                  about the award ceremony and any further information you may
                  need.
                </p>
                <p>
                  In the meantime, please keep an eye on your registered
                  WhatsApp number and email ID for communication from our team.
                </p>
                <p>
                  Should you require any additional information, please feel
                  free to reach out to us. We look forward to celebrating this
                  milestone with you!
                </p>
                <p>
                  Warm regards, <br />
                  Sonia Konjeti <br />
                  Founder & CEO - PULA Pune Ladies
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default NomineeBookingConfirm
